// import React from "react";
// import "./service.css";

// const WhatIDo = () => {
//   return (
//     <section className="what-i-do">
//       <div className="text-content">
//         <h2>What I do?</h2>
//         <p>
//         I bring ideas to life by blending software engineering with hardware innovation. From crafting dynamic web applications to building intelligent robotic systems, I design with purpose and precision.
//         </p>
//         <button className="btn">Say Hello!</button>
//       </div>

//       <div className="cards">
//         <div className="what-card">
//           <h3>Full Stack Development</h3>
//           <p>
//           Build scalable web applications with clean UI/UX, robust APIs, and efficient backend systems—from concept to cloud deployment.
//           </p>
//         </div>

//         <div className="what-card">
//           <h3>Embedded Systems & IoT</h3>
//           <p>
//           Design and develop smart devices using microcontrollers, sensors, and wireless communication to solve real-world problems.
//           </p>
//         </div>

//         <div className="what-card">
//           <h3>Robotics & Automation</h3>
//           <p>
//           Create autonomous or semi-autonomous systems by integrating control logic, hardware prototyping, and machine intelligence.
//           </p>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhatIDo;
import React from "react";
import "./service.css";

const WhatIDo = () => {
  return (
    <section className="what-i-do">
      <div className="text-content">
        <h2>What I Do as a Web Developer</h2>
        <p>
          As a passionate <strong>full stack web developer</strong>, I bring your digital ideas to life by combining modern web development with hardware innovation when needed. I specialize in building <strong>responsive websites</strong>, <strong>custom web applications</strong>, and smart systems that deliver real value and performance.
        </p>
        <button className="btn">Contact Me</button>
      </div>

      <div className="cards">
        <div className="what-card">
          <h3>Full Stack Web Development</h3>
          <p>
            I design and develop <strong>scalable web applications</strong> with clean <strong>UI/UX</strong>, secure <strong>RESTful APIs</strong>, and reliable backend systems. From front-end design to <strong>cloud deployment</strong>, I ensure every project is fast, user-friendly, and SEO-ready.
          </p>
        </div>

        <div className="what-card">
          <h3>Embedded Systems & IoT Solutions</h3>
          <p>
            I create <strong>smart IoT devices</strong> and <strong>embedded systems</strong> using microcontrollers, sensors, and wireless technologies. I build connected solutions that collect data, automate tasks, and add intelligence to everyday products.
          </p>
        </div>

        <div className="what-card">
          <h3>Robotics & Automation Development</h3>
          <p>
            I design and prototype <strong>robotic systems</strong> for <strong>automation</strong> and intelligent control. By integrating hardware, firmware, and software, I develop systems that can perform tasks autonomously and adapt to real-world environments.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatIDo;
